import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { getCurrentRole, hasPermission, Permission } from '../constants/roles';

interface RoleProtectedProps {
  permission: Permission;
  children: JSX.Element;
  fallback?: string;
}

const RoleProtected = ({
  permission,
  children,
  fallback = '/dashboard'
}: RoleProtectedProps) => {
  const auth = React.useContext(AuthContext);
  const location = useLocation();

  if (!auth?.authenticated) {
    return (
      <Navigate
        to='/authentication/signin'
        state={{ from: location }}
        replace
      />
    );
  }

  const role = getCurrentRole();
  if (!hasPermission(role, permission)) {
    return <Navigate to={fallback} replace />;
  }

  return children;
};

export default RoleProtected;
